import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { en, vi } from './translations.js';

export const coreOrganizationWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [
    { path: '/org/chart', component: () => import('./pages/OrgChartPage.js') },
    { path: '/org/employees', component: () => import('./pages/EmployeesPage.js') },
    { path: '/org/job-titles', component: () => import('./pages/JobTitlesPage.js') },
  ],
});
